"use client"
import { useLocation, Link } from "@/components/router-wrapper";
import AuthForm, { LoginForm, RegisterForm, ForgotPasswordForm } from "@external/landing/components/auth/AuthForm";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "../i18n/i18n";

const Auth = () => {
  const [location] = useLocation();
  const { t } = useTranslation();


  return (
    <div className="min-h-screen bg-black flex flex-col justify-center items-center px-4 py-16"
      style={{
        backgroundImage: "radial-gradient(circle, #000000f2 0%, #000000e6 50%, #000000f7 70%, #000000fa 90%, #000 100%), url(/images/wallpaper.jpeg)",
        backgroundPosition: "center, center",
        backgroundRepeat: "no-repeat, no-repeat",
        backgroundSize: "cover, cover",
        backgroundAttachment: "fixed",
        fontFamily: "Satoshi, sans-serif"
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-10 text-center"
      >
        <Link href="/" className="flex flex-row justify-center items-center">
          <img src="/images/logo.png" className="h-10" />
          <span className="font-bold text-white italic font-pilat" style={{ fontSize: "xx-large", marginLeft: "-4px", letterSpacing: "2px", fontWeight: "500" }}>BetUp</span>
        </Link>
        <p className="text-gray-400">
            {t("Coming soon...")}
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="mt-10 text-gray-500 text-sm text-center"
      >
        <p>&copy; {new Date().getFullYear()} BetUp.AI. {t("All rights reserved.")}</p>
      </motion.div>
    </div>
  );
};

export default Auth; 